import { useEffect, useState } from "react"

import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";

import { supportLanguages as _supportLanguages, getLanguageResources } from "../configs/languageConfigs"

const _LangIdKey = `langId`
const _LangNameKey = `langName`

const getStorageValue = (key) => (
    JSON.parse(localStorage.getItem(key))
)

const setStorageValue = (key, value) => (
    localStorage.setItem(key, JSON.stringify(value))
)

const getResources = () => {
    return getLanguageResources()
}
const getDefaultLanguage = () => {
    let a = _supportLanguages.filter(i => i?.isDefault === true)
    return a[0]
}

export const init = () => {

    let savedLangId = getStorageValue(_LangIdKey)
    let savedLangName = getStorageValue(_LangNameKey)

    let defaultLangCode = savedLangId;
    let defaultLangName = savedLangName;

    let resources = getResources()

    if (!savedLangId) {
        defaultLangCode = getDefaultLanguage()?.id
        defaultLangName = getDefaultLanguage()?.name
    }

    // console.log('defaultLangCode', defaultLangCode)

    i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init(
            {
                resources,
                lng: defaultLangCode,
                // "zh-CN", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
                // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
                // if you're using a language detector, do not define the lng option

                interpolation: {
                    escapeValue: false // react already safes from xss
                }
            },
            // function (err, t) {
            // initialized and ready to go!

            // }
        );

    setStorageValue(_LangIdKey, defaultLangCode)
    setStorageValue(_LangNameKey, defaultLangName)

}

export function useTranslations({
    ns: _nameSpaces = []
}) {

    // const [currentLanguageId, setCurrentLanguageId] = useState(
    //     getStorageValue(_LangIdKey) ? getStorageValue(_LangIdKey) : getDefaultLanguage()?.id
    // )
    // const [currentLanguageName, setCurrentLanguageName] = useState(
    //     getStorageValue(_LangNameKey) ? getStorageValue(_LangNameKey) : getDefaultLanguage()?.name
    // )

    const { nameSpaces, setNameSpaces } = useState(_nameSpaces)

    const {
        t: _t,
        i18n: _i18n
    } = useTranslation(_nameSpaces.length ? _nameSpaces : "");

    const getSupportLanguages = () => {
        let a = {}

        _supportLanguages.forEach(i => {
            a = {
                ...a,
                [`${i?.id}`]: `${i?.id}`
            }
        })

        return a
    }

    const getTranslations = () => {

        let langId = getStorageValue(_LangIdKey)

        let a = getLanguageResources()

        if (langId) {
            return a[langId]
        }

        return {}

    }

    const getCurrentLanguageId = () => getStorageValue(_LangIdKey)
    const getCurrentLanguageName = () => getStorageValue(_LangNameKey)

    const changeLanguage = (id) => {

        // get the language info
        let _lang = _supportLanguages.filter(i => i?.id === id)

        if (_lang.length > 0) {

            let langId = _lang[0]?.id
            let langName = _lang[0].name

            i18n.changeLanguage(langId);

            // console.log('changed to :', id)

            // setCurrentLanguageId(langId)
            // setCurrentLanguageName(langName)

            setStorageValue(_LangIdKey, langId)
            setStorageValue(_LangNameKey, langName)

        }
    }

    const t = (str, props = {}) => {

        if (_nameSpaces.length > 0) {
            // console.log('_nameSpaces', str, _nameSpaces)
            return _t(
                str,
                {
                    ns: _nameSpaces,
                    ...props
                }
            )
        }

        return _t(str)

    }

    return {
        init,
        getSupportLanguages,
        getCurrentLanguageId,
        getCurrentLanguageName,
        // currentLanguageId,
        // currentLanguageName,
        t,
        getTranslations,
        changeLanguage
    }
}